import { localStorageService } from "./localstorage-service";

const baseUrl = import.meta.env.VITE_API_BASE_URL;

export type RefreshSessionResult = "ok" | "unauthorized" | "error";

interface RefreshResponse {
  token?: string;
  refreshToken?: string;
}

let refreshInFlight: Promise<RefreshSessionResult> | null = null;

export const refreshSession = (): Promise<RefreshSessionResult> => {
  if (refreshInFlight) {
    return refreshInFlight;
  }

  refreshInFlight = (async (): Promise<RefreshSessionResult> => {
    const refreshToken = await localStorageService.getRefreshToken();
    if (!refreshToken) {
      return "unauthorized";
    }

    try {
      const response = await fetch(`${baseUrl}/auth/refresh`, {
        method: "POST",
        headers: {
          authorization: `Bearer ${refreshToken}`,
        },
      });

      if (response.status === 401 || response.status === 403) {
        return "unauthorized";
      }

      if (!response.ok) {
        return "error";
      }

      const data = (await response.json()) as RefreshResponse;
      if (!data?.token) {
        return "unauthorized";
      }

      localStorageService.setToken(data.token);
      if (data.refreshToken) {
        localStorageService.setRefreshToken(data.refreshToken);
      }

      return "ok";
    } catch {
      return "error";
    }
  })().finally(() => {
    refreshInFlight = null;
  });

  return refreshInFlight;
};
